import Image from 'next/image';
import Layout from '../../ui/layout';
import { Wrap, Button } from '../../styled';
import { TypeformButtonMain } from '../../components';
import {
  Intro,
  IntoCells,
  IntoCell,
  IntroHeading,
  IntroDescription,
  IntoSteps,
  IntoStep,
  Ul,
  UnlockFuture,
  UnlockFutureCells,
  UnlockFutureCell,
  H3,
  Text,
  HowWorks,
  Divider,
  HowWorksCell,
  H4,
  HowWorksInner,
  HowWorksCellText,
  Recommendations,
  RecommendationsInner,
  RecommendationsCell,
  Assurance,
  AssuranceInner,
  AssuranceCell,
  FootSizingSolution,
  FootSizingSolutionInner,
  FootSizingSolutionCell,
  Benefits,
  BenefitsItems,
  BenefitsItem,
  ECom,
  BookMeating,
  BookMeatingInner,
  WrapperCentered,
} from './styled';

import { introSteps, howWorks, benefits } from './content';

import introImage1 from './images/intro-image-1.png';
import introImage2 from './images/intro-image-2.png';
import footScannerLogo from './images/logo.svg';
import recommendationsImage from './images/tailored-recommendations.jpg';
import assuranceImage from './images/accuracy-assurance.png';

const FootScanner = () => (
  <Layout>
    <Intro>
      <Wrap>
        <IntoCells>
          <IntoCell>
            <IntroHeading>EYEFITU FOOTSCanner™</IntroHeading>
            <IntroDescription>
              Revolutionizing Footwear Sizing with AI-Powered Precision
            </IntroDescription>
            <Ul>
              <li>Take two photos; no mobile app needed</li>
              <li>Accurate recommendation for all styles of footwear</li>
              <li>Reduces returns and boosts conversions</li>
            </Ul>
            <Button as={TypeformButtonMain}>Schedule a demo</Button>
          </IntoCell>
          <IntoCell>
            <Image src={introImage1} width="390" height="778" alt="" />
          </IntoCell>
          <IntoCell>
            <Image src={introImage2} width="390" height="778" alt="" />
          </IntoCell>
        </IntoCells>
        <IntoSteps>
          {introSteps.map(({ icon, text }) => (
            <IntoStep key={text}>
              <H4>{text}</H4>
              <Image src={icon} width="80" height="80" alt={text} />
            </IntoStep>
          ))}
        </IntoSteps>
      </Wrap>
    </Intro>
    <UnlockFuture>
      <Wrap>
        <UnlockFutureCells>
          <UnlockFutureCell>
            <video
              src="/images/footscanner/demo.mp4"
              autoPlay
              loop
              muted
              playsInline
            />
          </UnlockFutureCell>
          <UnlockFutureCell>
            <Image
              src={footScannerLogo}
              width="230"
              height="66"
              alt="EyeFitU FootScanner"
            />
            <H3>Unlock the Future of Footwear Sizing</H3>
            <Text>
              Your customers can easily find their right size by simply taking a
              photo of each foot on a piece of white paper (A4 or Letter size),
              all directly within their browser, no need to compare it to
              brand’s size chart nor download an app.
            </Text>
          </UnlockFutureCell>
        </UnlockFutureCells>
      </Wrap>
    </UnlockFuture>
    <HowWorks>
      <Wrap>
        <H3>How Our FootScanner™ Works</H3>
        <HowWorksInner>
          {howWorks.map(({ title, text }, index) => (
            <>
              {index > 0 && <Divider />}
              <HowWorksCell key={title}>
                <H4>{title}</H4>
                <HowWorksCellText>{text}</HowWorksCellText>
              </HowWorksCell>
            </>
          ))}
        </HowWorksInner>
      </Wrap>
    </HowWorks>
    <Recommendations>
      <Wrap>
        <RecommendationsInner>
          <RecommendationsCell>
            <Image
              src={recommendationsImage}
              width="600"
              height="372"
              alt="Personalized Recommendations"
            />
          </RecommendationsCell>
          <RecommendationsCell>
            <H3>Personalized Recommendations</H3>
            <Text>
              Our algorithms cater to different foot shapes, providing
              personalized recommendations for shoe sizes tailored to each user.
              From narrow to wide fits, EyeFitU FootScanner™ ensures precise
              size suggestions.
            </Text>
          </RecommendationsCell>
        </RecommendationsInner>
      </Wrap>
    </Recommendations>
    <Assurance>
      <Wrap>
        <AssuranceInner>
          <AssuranceCell>
            <H3>Accuracy Assurance</H3>
            <Text>
              Rigorously tested across various demographics, our Machine
              Learning software <b>continuously refines</b> its models for
              utmost accuracy.
            </Text>
          </AssuranceCell>
          <AssuranceCell>
            <Image
              src={assuranceImage}
              width="400"
              height="411"
              alt="Accuracy Assurance"
            />
          </AssuranceCell>
        </AssuranceInner>
      </Wrap>
    </Assurance>
    <FootSizingSolution id="demo">
      <Wrap>
        <FootSizingSolutionInner>
          <FootSizingSolutionCell>
            <iframe
              src="https://player.vimeo.com/video/1025079393?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              width="286.88"
              height="621.07"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              title="Explore Our Foot Sizing Solution with Atomic"
              loading="lazy"
            />
          </FootSizingSolutionCell>
          <FootSizingSolutionCell>
            <H3>Explore Our Foot Sizing Solution with Atomic</H3>
            <Text>
              See our online AI shoe sizing tool in action with Atomic — watch
              how customers find their perfect ski boots online!
            </Text>
          </FootSizingSolutionCell>
        </FootSizingSolutionInner>
      </Wrap>
    </FootSizingSolution>
    <Benefits>
      <Wrap>
        <H3>Key Benefits</H3>
        <BenefitsItems>
          {benefits.map(({ icon, text }) => (
            <BenefitsItem key={text}>
              <Image src={icon} width="80" height="104" alt={text} />
              <H4>{text}</H4>
            </BenefitsItem>
          ))}
        </BenefitsItems>
        <H4>
          Trust EyeFitU FootScanner™ for dependable footwear sizing, eliminating
          guesswork.
        </H4>
      </Wrap>
    </Benefits>
    <ECom>
      <Wrap>
        <H3>Fast and easy integration onto all e-commerce platforms</H3>
        <WrapperCentered>
          <Button as={TypeformButtonMain}>Get a quote</Button>
        </WrapperCentered>
        <H4>
          Are you facing shoe sizing and fit challenges? Contact us today and
          discover how EyeFitU FootScanner™ can help your brand boost
          conversions and basket size, while minimizing returns.
        </H4>
      </Wrap>
    </ECom>
    <BookMeating>
      <BookMeatingInner>
        <H3>Book a Meeting</H3>
        <Button as={TypeformButtonMain}>{`Let's talk`}</Button>
      </BookMeatingInner>
    </BookMeating>
  </Layout>
);

export default FootScanner;
